import { Box, Typography } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import DashboardLayout from "utils/LayoutContainers/DashboardLayout";
import DashboardNavbar from "utils/Navbars/DashboardNavbar";
// import alysLogo from "assets/images/logos/alys_logo_gradient.png";
// import insightsLogo from "assets/images/logos/insights_logo.png";
import { ReactComponent as TrophyIcon } from "assets/images/logos/trophy.svg";
import Cabinet from "./components/Cabinet";

const TrophyCabinet = () => {
  const showNotification = (type, message) => {
    enqueueSnackbar(
      JSON.stringify({
        icon: type,
        title: type === "success" ? "Success" : "Error",
        text: message,
      }),
      {
        variant: "custom",
      }
    );
  };

  return (
    <DashboardLayout>
      <Box sx={{ display: "flex", flexDirection: "column", height: "calc(100vh - 24px)" }}>
        <DashboardNavbar />

        <Box display="flex" alignItems="center" mb={2}>
          <TrophyIcon height="60px" width="60px" />
          <Typography variant="h4" pt={1.5}>
            Trophy Cabinet
          </Typography>
        </Box>
        <Box sx={{ flexGrow: 1, borderRadius: "0.75rem", backgroundColor: "#232324" }}>
          <Cabinet showNotification={showNotification} />
        </Box>
      </Box>
    </DashboardLayout>
  );
};

export default TrophyCabinet;
